module.exports = __webpack_public_path__ + "img/zeroTwo.3d85b512.png";